var ComponentErrorCodes;
(function (ComponentErrorCodes) {
    ComponentErrorCodes["MISSING_PROPS"] = "missing-props";
    ComponentErrorCodes["FETCH_ERROR"] = "fetch-error";
    ComponentErrorCodes["PATCH_ERROR"] = "patch-error";
    ComponentErrorCodes["POST_ERROR"] = "post-error";
    ComponentErrorCodes["UNKNOWN_ERROR"] = "unknown-error";
    ComponentErrorCodes["TOKENIZE_ERROR"] = "tokenize-error";
    ComponentErrorCodes["NOT_AUTHENTICATED"] = "not-authenticated";
    ComponentErrorCodes["INVALID_PARAMETER"] = "invalid-parameter";
    ComponentErrorCodes["PROVISIONING_REQUESTED"] = "provisioning-already-requested";
})(ComponentErrorCodes || (ComponentErrorCodes = {}));
var ComponentErrorSeverity;
(function (ComponentErrorSeverity) {
    ComponentErrorSeverity["INFO"] = "info";
    ComponentErrorSeverity["WARNING"] = "warning";
    ComponentErrorSeverity["ERROR"] = "error";
})(ComponentErrorSeverity || (ComponentErrorSeverity = {}));

export { ComponentErrorCodes as C, ComponentErrorSeverity as a };
